/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Dropdown from 'DesignSystem/Dropdown/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Images/Misc/Content/PatientImage/Content/Content/SendSecurely/Content/Recipients/Content",
  onChange,
  onSubmit,
  isSubmitting
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let responsiblePartiesValueData = fromData.useDataValue({ viewPath,
context: 'responsible_parties',
})
let selectionPersonIdValueData = fromData.useDataValue({ viewPath,
context: 'selection',
path: 'person_id',
})
let selectionPersonIdChangeData = fromData.useDataChange({ viewPath,
context: 'selection',
path: 'person_id',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let selectionSubmitData = fromData.useDataSubmit({ viewPath,
context: 'selection',
})
let selectionIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'selection',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Dropdown
  viewPath={`${viewPath}/Dropdown`}
 backgroundColor="rgba(0,0,0,0.03)"
 data="responsible_parties"
 from={responsiblePartiesValueData}
 data="selection.person_id"
 selected={selectionPersonIdValueData}
 onClick={selectionPersonIdChangeData}
 text="Select a recipient"
 field="name"
 label="Select a recipient"
 alignItems="stretch"
 textAlign="left"
 minWidth={300}
 maxWidth="100%"
 width="100%"
 height={300}
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../No'))}
 type="secondary"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Cancel"
/>
)}
</TysiaButton>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 marginLeft={dtSpaceXs}
 data="selection"
 onClick={selectionSubmitData}
 isDisabled={selectionIsSubmittingData}
 type="primary"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Send"
/>
)}
</TysiaButton>
</div>
</div>
{children}
</React.Fragment>)
}